import {defineMessages} from 'react-intl';

export default defineMessages({
  btnName: {
    defaultMessage: 'Book a Lab',
    id: 'LabBookingButton.btnName',
  }
});
